import {FC, useCallback} from 'react';
import {useRecoilValue, useSetRecoilState} from 'recoil';

import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

import {DeviceRow} from './DeviceRow';

import {
  currentDeviceState,
  deviceControlModeState,
  deviceControlState,
  devicesState,
} from '../../../../store/deviceModels/atoms';
import {IDevice} from '../../../../shared/types/device.types';

interface ITableBodyContainer {
  rowsPerPage: number;
}

export const TableBodyContainer: FC<ITableBodyContainer> = ({rowsPerPage}) => {
  const {content} = useRecoilValue(devicesState);
  const setDevice = useSetRecoilState(currentDeviceState);
  const setModeOfUserAccountControl = useSetRecoilState(deviceControlModeState);
  const setOpenUserAccountControl = useSetRecoilState(deviceControlState);

  const toEditDevice = useCallback(
    (device: IDevice) => () => {
      setDevice(device);
      setModeOfUserAccountControl('EDIT');
      setOpenUserAccountControl(true);
    },
    [],
  );

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows = rowsPerPage - content.length;

  return (
    <TableBody>
      {content.map((row) => {
        return <DeviceRow key={row.id} toEditDevice={toEditDevice} row={row} />;
      })}
      {emptyRows > 0 && (
        <TableRow
          style={{
            height: 37 * emptyRows,
          }}
        >
          <TableCell colSpan={10} />
        </TableRow>
      )}
    </TableBody>
  );
};
